import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { ICalendar, ICalendarSelectionSummary } from '../../common/types/apiSchema';

export {
  ITravelPeriod,
  ITravelPeriodDraft,
  ITravelPeriodData,
  GET_FILTERS_DATA,
  GET_TRAVEL_PERIOD_DATA,
  GET_CALENDAR,
  ICalendarQueryData,
  ICalendarQueryVariables,
  GET_CALENDAR_SELECTION_SUMMARY,
  ICalendarSelectionSummaryQueryData,
  ICalendarSelectionSummaryQueryVariables,
};

interface ITravelPeriod {
  __typename?: string;
  startDate: string;
  endDate: string;
  hasInitialisedData: boolean;
}

interface ITravelPeriodDraft {
  __typename?: string;
  startDate: string;
  endDate: string;
}

interface ITravelPeriodData {
  travelPeriod: ITravelPeriod;
  travelPeriodDraft: ITravelPeriodDraft;
}

const GET_FILTERS_DATA: DocumentNode = gql`
  {
    travelPeriod @client {
      __typename
      hasInitialisedData @client
      startDate @client
      endDate @client
    }
    travelPeriodDraft @client {
      __typename
      endDate @client
      startDate @client
    }
  }
`;

const GET_TRAVEL_PERIOD_DATA: DocumentNode = gql`
  {
    travelPeriod @client {
      __typename
      hasInitialisedData @client
      startDate @client
      endDate @client
    }
    isLoadingDraftDeals @client
    numberOfDeals @client
    travelPeriodDraft @client {
      __typename
      startDate @client
      endDate @client
    }
  }
`;

const GET_CALENDAR: DocumentNode = gql`
  query getCalendar(
    $saleId: String!
    $offerId: String!
    $rooms: Int!
    $currency: String!
    $affiliate: String!
    $territory: String!
  ) {
    sale(saleId: $saleId, currency: $currency, affiliate: $affiliate, territory: $territory) {
      offer(offerId: $offerId) {
        calendar(rooms: $rooms) {
          currency {
            currencyCode
          }
          stayType
          calendarEntries {
            date
            rates {
              rate {
                unit
                forDisplay
              }
            }
            minLengthOfStay
            maxLengthOfStay
            closedToArrival
            closedToDeparture
            checkOutDayOnly
          }
        }
      }
    }
  }
`;

interface ICalendarQueryData {
  calendar: ICalendar;
}

interface ICalendarQueryVariables {
  saleId: string;
  offerId: string;
  rooms: number;
  currency: string;
  affiliate: string;
  territory: string;
}

const GET_CALENDAR_SELECTION_SUMMARY: DocumentNode = gql`
  query getCalendarSelectionSummary(
    $saleId: String!
    $offerId: String!
    $rooms: Int!
    $currency: String!
    $affiliate: String!
    $territory: String!
    $checkin: String!
    $checkout: String!
    $rebookedReservationId: String
  ) {
    sale(saleId: $saleId, currency: $currency, affiliate: $affiliate, territory: $territory) {
      offer(offerId: $offerId) {
        calendarSelectionSummary(
          rooms: $rooms
          checkin: $checkin
          checkout: $checkout
          rebookedReservationId: $rebookedReservationId
        ) {
          cancellationSelectionInformation
          resortFeeDisclaimer
          rateCodes
          priceBreakdown {
            items {
              concept
              isTaxOrFee
              price {
                unit
                forDisplay
              }
            }
            total {
              forDisplay
            }
          }
          alreadyPaidBreakdown {
            items {
              concept
              isTaxOrFee
              price {
                unit
                forDisplay
              }
            }
            total {
              forDisplay
            }
          }
          balance {
            unit
            forDisplay
          }
        }
      }
    }
  }
`;

interface ICalendarSelectionSummaryQueryData {
  calendar: ICalendarSelectionSummary;
}

interface ICalendarSelectionSummaryQueryVariables {
  saleId: string;
  offerId: string;
  rooms: number;
  currency: string;
  affiliate: string;
  territory: string;
  checkin: string;
  checkout: string;
  rebookedReservationId?: string;
}
